import { AttributeType, StringSubType } from "@evergis/api";
import { IconTypesKeys } from "@evergis/ui";

export type FieldType = {
  text: string;
  value: AttributeType | StringSubType;
  extra?: AttributeType[];
  langKey?: string;
  description?: string;
  icon?: IconTypesKeys;
};

export const fieldTypes: FieldType[] = [
  { text: "Текст", value: AttributeType.String, langKey: "text", icon: "text" },
  { text: "Целое число", value: AttributeType.Int64, extra: [AttributeType.Int32], langKey: "integer", icon: "int" },
  { text: "Дробное число", value: AttributeType.Double, langKey: "double", icon: "double" },
  { text: "Дата и время", value: AttributeType.DateTime, langKey: "dateTime", icon: "datetime" },
  { text: "Точка", value: AttributeType.Point, langKey: "point", icon: "geom_point" },
  { text: "Полигон", value: AttributeType.MultiPolygon, langKey: "polygon", icon: "geom_polygon" },
  { text: "Изображение", value: StringSubType.Image, langKey: "image", icon: "image" },
  { text: "Вложение", value: StringSubType.Attachments, langKey: "attachment", icon: "attachment" },
];

export const allFieldTypes: FieldType[] = [
  ...fieldTypes,
  { text: "Линии", value: AttributeType.Polyline, langKey: "lines", icon: "geom_polyline" },
];

export const geometryFieldTypes: FieldType[] = [{ text: "Точки", value: AttributeType.Point, langKey: "points" }];

export const validFieldTypes: AttributeType[] = [
  AttributeType.String,
  AttributeType.Int32,
  AttributeType.Int64,
  AttributeType.DateTime,
  AttributeType.Double,
];

function getFieldType(type: AttributeType): FieldType {
  for (const fieldType of allFieldTypes) {
    if (fieldType.value === type || (fieldType.extra && fieldType.extra.includes(type))) {
      return fieldType;
    }
  }
}

export function getFieldTypeValue(type: AttributeType, subType?: StringSubType): string {
  if (subType && subType === StringSubType.Image) {
    return StringSubType.Image;
  }

  if (subType && subType === StringSubType.Attachments) {
    return StringSubType.Attachments;
  }

  const fieldType = getFieldType(type);

  return fieldType && fieldType.value;
}

export function getFieldTypeLangKey(type: AttributeType, subType?: StringSubType): string {
  if (subType && (subType === StringSubType.Image || subType === StringSubType.Attachments)) {
    return allFieldTypes.find(({ value }) => value === subType).langKey;
  }

  const fieldType = getFieldType(type);

  return fieldType ? fieldType.langKey : "";
}

export function getFieldTypeIcon(type: AttributeType, subType?: StringSubType): string {
  if (subType && (subType === StringSubType.Image || subType === StringSubType.Attachments)) {
    return allFieldTypes.find(({ value }) => value === subType).icon;
  }

  const fieldType = getFieldType(type);

  return fieldType ? fieldType.icon : "";
}
